import React from 'react';
import Modal from '../../../../../Components/Modal/Modal';
import { useTreatmentContext } from '../../../../../Services/TreatmentContext';
import VerifyVersion from './VerifyVersion';
import useTranslation from '../../../../../Hooks/useTranslation';
import { NcziEnum } from '../../../../../graphql/graphql';

interface Props {
	opened: boolean;
	onClose: () => void;
	item: NcziEnum;
}

const VerifyVersionModal: React.FC<Props> = props => {
	const { opened, onClose, item } = props;
	const { t } = useTranslation();
	const { isCase } = useTreatmentContext();

	return (
		<Modal
			opened={opened}
			onClose={onClose}
			fullScreen={false}
			wrapChat={isCase}>
			<Modal.Header title={t('nczi.verifyEnumVersionModal.title') + ' ' + item.oid} />
			<Modal.Content>
				<VerifyVersion
					onClose={onClose}
					item={item}
				/>
			</Modal.Content>
		</Modal>
	);
};

export default VerifyVersionModal;
